import dayjs from 'dayjs';
import React, { useCallback } from 'react';
import styled from 'styled-components';

import { useSetRecoilState } from 'recoil';
import { useNavigate } from 'react-router-dom';
import { calendarSelectedItemIdState } from '@atom/calendar/calendar';
import CalendarButton from './CalendarButton';

const NavContainer = styled.div`
  display: flex;
  gap: 8px;
  justify-content: space-between;
  align-items: center;

  h6 {
    font-size: 17px;
    font-weight: 800;
  }
`;

const HeaderDate = styled.button`
  transition: color 0.2s;
  color: var(--textColor);

  &:hover {
    color: var(--primaryColor);
    cursor: var(--hoverCursorURL), pointer;
  }
`;
const ButtonWrap = styled.div`
  display: flex;
  gap: 6px;
`;

type Props = {
  focusDate: Date;
  setFocusDate: any;
};
function Nav({ focusDate, setFocusDate }: Props) {
  const setSelectedId = useSetRecoilState(calendarSelectedItemIdState);
  const navigate = useNavigate();

  const handleClickPrevHandler = useCallback(() => {
    const prevMonth = dayjs(focusDate).set(
      'month',
      dayjs(focusDate).month() - 1,
    );

    setFocusDate(prevMonth);
  }, [focusDate]);

  const handleClickNextHandler = useCallback(() => {
    const nextMonth = dayjs(focusDate).set(
      'month',
      dayjs(focusDate).month() + 1,
    );
    setFocusDate(nextMonth);
  }, [focusDate]);

  const handleClickHeader = useCallback(() => {
    setSelectedId('');
    // navigate(`calendar`);
  }, []);

  return (
    <NavContainer>
      <HeaderDate onClick={handleClickHeader}>
        <h6>
          {dayjs(focusDate).format('YYYY')}. {dayjs(focusDate).format('M')}
        </h6>
      </HeaderDate>

      <ButtonWrap>
        <CalendarButton
          type="left"
          onClick={handleClickPrevHandler}
          disabled={false}
        />
        <CalendarButton
          type="right"
          onClick={handleClickNextHandler}
          disabled={false}
        />
      </ButtonWrap>
    </NavContainer>
  );
}

export default Nav;
